// @import dependencies
import React, {Component, CSSProperties} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ScreenwrapperModuleLayout} from 'app_components/modules/screenWrapper/screenwrapper'
// @end

// @import events
import * as InteractionActions from 'app_events/interaction/actions'
// @end

// @import utils
// @end

// @import services
import storeService from 'app_services/storeService';
import EditorService from 'app_services/editor/editorService';
// @end

// @import types
import * as InteractionTypes from 'app_events/interaction/types'
import { store } from 'app_storage/redux-storage';
// @end

// @ADD Component types
interface IScreenwrapperModuleProps {
  children?: any
  className?: string
  style?: CSSProperties
}
interface IScreenwrapperModuleState {
  showInteraction: boolean
  resourceData?: any
  path?: InteractionTypes.IPathInteraction
  typeInteraction: InteractionTypes.TypesInteraction;
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ScreenwrapperModule extends Component<IScreenwrapperModuleProps, IScreenwrapperModuleState> {

  private editorService = new EditorService()
  private storeObject = store

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IScreenwrapperModuleProps) {
    super(props)
    this.state = {
      showInteraction: false,
      resourceData: undefined,
      path: undefined,
      typeInteraction: 'survey'
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    storeService?.subscribe('interaction.path', this.handleChangeInteraction, true)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('interaction.path', this.handleChangeInteraction)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  /**
   * @INFO Cambia el path de la interacción
   * @param path
   */
  public handleChangeInteraction = (path?: InteractionTypes.IPathInteraction) => {
    if(path){
      // @INFO Si hay path hacer el fetch del recurso y muestro la interacción
      if (path?.typeInteraction === 'survey' || path?.typeInteraction === 'characterization_survey') {
        this.getResourceData(path)
      } else {
        this.setState({resourceData: undefined, showInteraction: true, typeInteraction: path.typeInteraction, path: {...path}})
      }
    }else{
      // @INFO Si no hay path limpio la data del recurso y no muestro la interacción
      this.setState({showInteraction: false, resourceData: undefined, path: undefined})
    }
  }

  /**
   * @INFO Obtener la data del recurso
   */
  public getResourceData = async (path: InteractionTypes.IPathInteraction) => {
    const response = await this.editorService.getAcademicResourceData({
      academic_resource_config: path.academic_resource_config,
      survey: path.survey
    },
    path.config_category)
    if(response?.code === 200 && response?.academicResourceData){
      this.setState({resourceData: response?.academicResourceData, typeInteraction: path.typeInteraction, showInteraction: true, path: {...path}})
    }
  }

  /**
   * @INFO Se cierra una interacción
   */
  public handleCloseInteraction = (data?: any) => {
    this.storeObject.dispatch(InteractionActions.deleteInteractionAction())
    if (data?.reload) {
      window.location.reload()
    }
  }

  render() {
    return(
      <ScreenwrapperModuleLayout
        {...this.props}
        path={this.state.path}
        typeInteraction={this.state.typeInteraction}
        showInteraction={this.state.showInteraction}
        resourceData={this.state.resourceData}
        onClose={this.handleCloseInteraction}
      />
    )
  }
}

export default connect(mapStatesToProps)(ScreenwrapperModule)
